<template>
  <form class=" mt-2" id="form-modal">

    <!-- title input -->
    <div class="form-group">
      <label class="label-form">Title<span style="color: red">*</span>:</label>
      <input type="text" class="form-control" v-model="categoryForm.title" placeholder="The title of the category">
    </div>

    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Description<span style="color: red">*</span>:</label>
      <textarea class="form-control" v-model="categoryForm.description"
        placeholder="The description of the category"></textarea>
    </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" @click="resetForm" class="btn btn-secondary btn-sm" data-dismiss="modal">Close</button>
      <button type="button" class="btn btn-primary btn-sm ml-1" @click="save">Save</button>
    </div>
  </form>
</template>
<script>
  import Multiselect from 'vue-multiselect';
  import {isEmpty} from "lodash/lang";

  export default {
    components: {
      Multiselect
    },
    props: [
      'action', 'formData'
    ],
    data: function () {
      return {
        categoryForm: {},
      };
    },
    computed: {
      FAQcategories: function () {
        return this.$store.getters['faqcategories/search']
      },
      users: function () {
        return this.$store.getters['users/usersSearch'];
      }
    },
    beforeCreate() {
      if (this.action == 'create'){
        this.categoryForm = {};
      }
    },
    created: function () {
      if (this.action == 'update') {
        this.categoryForm = JSON.parse(JSON.stringify(this.formData));
      }

    },
    mounted() {
      console.log(this.action)
      if (this.action == 'create'){
        console.log("here")
        this.categoryForm = {};
      }
    },

    methods: {
      searchCategories(query) {

        let self = this;
        (window._.debounce(
          async function (vm, query) {
            if (query != '') {
              await vm.$store.dispatch('faqcategories/searchCategories', [query, self.categoryForm.slug]);
            }
          }
          , 300))(this, query);
      },
      searchUsers(query) {

        (window._.debounce(
          async function (vm, query) {
            if (query != '') {
              await vm.$store.dispatch('users/searchUsers', query);
            }
          }
          , 300))(this, query);
      },
      save() {

        if (this.categoryForm.title === undefined || isEmpty(this.categoryForm.title)) {
          this.$toast.error("Title Fields is required.");
          return false;
        }

        if (this.categoryForm.title !== undefined || !isEmpty(this.categoryForm.title)){
          if (this.containsOnlyNumbers(this.categoryForm.title)){
            this.$toast.error("Please enter a valid title.");
            return false;
          }
        }

        if (this.categoryForm.description === undefined || isEmpty(this.categoryForm.description)) {
          this.$toast.error("Description Fields is required.");
          return false;
        }

        if (this.action == 'create') {
          this.create(this.categoryForm);
        } else if (this.action == 'update') {

          this.update(this.categoryForm);
        }
      },
      create(FAQcategory) {
        let self = this;
        this.$store.dispatch('faqcategories/createCategory', FAQcategory)
          .then(() => {
            self.categoryForm = {};
            // send successful message
            this.$toast.success(`${FAQcategory.title} FAQ category has been added successfully`);
            window.$('#modal').modal('hide');
            this.$store.dispatch("faqcategories/getAllFAQCategories", 1);
          })
          .catch((error) => {
            let response = error.response;
            if (response.data.errors) {
              Object.keys(response.data.errors).forEach((key) => {
                response.data.errors[key].forEach((errorMsg) => {
                  this.$toast.error(errorMsg);
                });
              });
            }
          });
      },
      update(FAQcategory) {
        this.$store.dispatch('faqcategories/updateCategory', FAQcategory)
          .then(() => {
            // send successful message
            this.$toast.success(`${FAQcategory.title} FAQ category has been updated successfully`);
            window.$('#modal').modal('hide');
            this.$store.dispatch("faqcategories/getAllFAQCategories", 1);
          })
          .catch((error) => {
            let response = error.response;
            if (response.data.errors) {
              Object.keys(response.data.errors).forEach((key) => {
                response.data.errors[key].forEach((errorMsg) => {
                  this.$toast.error(errorMsg);
                });
              });
            }
          });
      },
      containsOnlyNumbers(input) {
        return !isNaN(input);
      },
      resetForm(){
        this.categoryForm = {};
      },
    }

  }
</script>